import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
import LandingPageNavbar from "../components/LandingPageNavbar";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import Image1 from "../assets/images/bookappointment/image-1.jpg";

function BookAppointment({ setPageTitle }) {

    useEffect(() => {
        setPageTitle("Book an Appointment - Bait Al Anaqah");
    }, [setPageTitle]);

    return (
        <>
            <Helmet>
                <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
                <meta name="title" property="og:title" content={setPageTitle}></meta>
                <meta property="og:type" content="website" />
                <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
                <meta name="image" property="og:image" content={Image1} />
                <link rel="canonical" href="https://baitalanaqah.com/book-appointment" />
            </Helmet>
            <LandingPageNavbar />
            <div className="vh-100 bg-dark overflow-hidden background-image d-flex align-items-center">
                <Container>
                    <Row>
                        <Col className="text-light my-lg-auto mb-4">
                            <h2 className="display-4">
                                Alteration Service At Your Doorstep.
                            </h2>
                        </Col>
                        <Col lg={4} className="ms-auto">
                            <Col className="p-4 bg-white shadow-lg">
                                <Form>
                                    <Form.Floating className="mb-3">
                                        <Form.Control
                                            id="name"
                                            type="text"
                                            placeholder="Name *"
                                            className="rounded-0 border-0 border-bottom"
                                        />
                                        <label htmlFor="name">Name *</label>
                                    </Form.Floating>
                                    <Form.Floating className="mb-3">
                                        <Form.Control
                                            id="name"
                                            type="number"
                                            placeholder="Mobile Number *"
                                            className="rounded-0 border-0 border-bottom"
                                        />
                                        <label htmlFor="name">Mobile Number *</label>
                                    </Form.Floating>
                                    <Form.Floating className="mb-3">
                                        <Form.Control
                                            id="name"
                                            type="email"
                                            placeholder="Email Address *"
                                            className="rounded-0 border-0 border-bottom"
                                        />
                                        <label htmlFor="name">Email Address *</label>
                                    </Form.Floating>
                                    <Form.Floating className="mb-3">
                                        <Form.Control
                                            id="name"
                                            type="date"
                                            placeholder="Date *"
                                            className="rounded-0 border-0 border-bottom"
                                        />
                                        <label htmlFor="name">Date *</label>
                                    </Form.Floating>
                                    <div className="mb-3 px-2">
                                        <label className="mb-2">Select Slot</label><br />

                                        <input type="radio" class="btn-check mb-3" name="options-base" id="option5" autocomplete="off" />
                                        <label class="btn btn-light" for="option5">9:00</label>

                                        <input type="radio" class="btn-check mb-3" name="options-base" id="option6" autocomplete="off" />
                                        <label class="btn btn-light" for="option6">10:00</label>

                                        <input type="radio" class="btn-check mb-3" name="options-base" id="option7" autocomplete="off" />
                                        <label class="btn btn-light" for="option7">11:00</label>

                                        <input type="radio" class="btn-check mb-3" name="options-base" id="option8" autocomplete="off" />
                                        <label class="btn btn-light" for="option8">12:00</label>

                                        <input type="radio" class="btn-check mb-3" name="options-base" id="option9" autocomplete="off" />
                                        <label class="btn btn-light" for="option9">13:00</label>

                                        <input type="radio" class="btn-check mb-3" name="options-base" id="option10" autocomplete="off" />
                                        <label class="btn btn-light" for="option10">14:00</label>
                                    </div>
                                    <div className="d-grid gap-2">
                                        <Button variant="dark" className="rounded-0" type="submit" size="lg">
                                            Book Now
                                        </Button>
                                    </div>
                                </Form>
                            </Col>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default BookAppointment;
